<div class="page-header">
	<h1 class="page-header__title">{{ 'news.title' | translate }}</h1>
	<div class="page-header__actions">
		<a
			claimDirective
			[claims]="[
				{
					claimType: ClaimTypes.News,
					claimValues: [ClaimValues.Create]
				}
			]"
			routerLink="/nieuws/toevoegen"
			nz-button
			nzType="primary">
			{{ 'common.add' | translate }}
			<i class="fa-regular fa-plus"></i>
		</a>
	</div>
</div>

<app-news-overview-table
	[data]="(tableData$ | async)!"
	(delete)="onDeleteConfirm($event)"
	(queryParamsChange)="onQueryParamsChange($event)"
	(changeSequence)="onSequenceChange($event)"
	(onResetOverview)="onResetOverview()" 
	(changeShowOnlineEmitter)="onChangeShowOnline($event)"
	/>